<template>
    <div class="page_content" v-html="value" />
</template>

<script>
export default {
    props: {
        value: {
            type: String,
            required: true
        }
    }
};
</script>
